/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { Boundary } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useTranslation } from 'react-i18next';
import firebase from 'firebase/firebase';
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter
} from 'react-table';
import { CustomTable } from '../../../components/common';

const Payments = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const [dataPayments, setDataPayments] = useState([
    {
      col1: <Skeleton width={30} />,
      col2: <Skeleton width={30} />,
      col3: <Skeleton width={30} />,
      col4: <Skeleton width={30} />
    }
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await firebase.getPayments();
      const rows = [];
      snapshot.payload.payments.map((payment) =>
        rows.push({
          col1: <div style={{ padding: '2rem' }}>{payment.company}</div>,
          col2: `${payment.amount} ${payment.currency}`,
          col3: `${payment.tax} ${payment.currency}`,
          col4: new Date(payment.date)
        })
      );
      setDataPayments(rows);
    };
    fetchData().catch(console.error);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: t('productTableName'),
        accessor: 'col1'
      },
      {
        Header: t('paymentAmount'),
        accessor: 'col2'
      },
      {
        Header: t('paymentTax'),
        accessor: 'col3'
      },
      {
        Header: t('paymentDate'),
        accessor: 'col4',
        sortType: 'datetime'
      }
    ],
    []
  );

  const tableInstancePayments = useTable(
    { columns, data: dataPayments, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Boundary>
      <CustomTable
        tableInstance={tableInstancePayments}
        title={t('titlePayments')}
      />
    </Boundary>
  );
};

export default withRouter(Payments);
